export const getters = {
  isRootFolder: state => state.paginatedDocumentsCurrentFolderId === 0,
  isRecentFolder: state => state.paginatedDocumentsCurrentFolderId === 'recentFolder',
  isTodoFolderAccessible: state => state.fullTree.children?.some(document => document.specialFolder === 'todo'),
}
